import React from 'react';
import AppShell from '~/components/shared/AppShell/AppShell';
import useAddUpdateApplicationSteps from './hooks/useAddUpdateApplicationSteps/useAddUpdateApplicationSteps';
import { getCurrentStepComponent } from './utils/getCurrentStepComponent/getCurrentStepComponent.utils';
import { showStart } from './utils/showStart/showStart.utils';
import { showFinished } from './utils/showFinished/showFinished.utils';
import Finished from './components/shared/states/Finished/Finished';
import NoQCode from './components/shared/states/NoQCode/NoQCode';
import { noSteps } from './utils/noSteps/noSteps.utils';
import NoSteps from './components/shared/states/NoSteps/NoSteps';
import { noQCode } from './utils/noQCode/noQCode.utils';
import Loading from './components/shared/states/Loading/Loading';
import { useGetClientData } from './hooks/useGetClientData/useGetClientData';
import ErrorComponent from './components/shared/states/Error/Error';
import NextStepButton from './components/shared/buttons/NextStepButton/NextStepButton';
import PreviousStepButton from './components/shared/buttons/PreviousStepButton/PreviousStepButton';
import CheckPoint from './components/shared/states/Checkpoint/Checkpoint';
import { StandardStepContent } from '~/styles/BaseStyledComponents';
import { StandardStepNavbarWrapper } from './UpdateApplicationStandalone.styled';
import { useAddClientDataToState } from './hooks/useAddClientDataToState/useAddClientDataToState';
import { AppUuidConfig } from './types';

// Note: Using app_uuid from backend (can be accessed like clientData?.applicationUuid) in the future,
// we might get the app config like this from the backend.
// But to not do too much lets just hardcode it for now.
const PHASE_1_CONFIG: AppUuidConfig = { steps: ['enable_banking'] };

const UpdateApplicationStandAlone = () => {
  const {
    isFetchingClientData,
    isError,
    clientData,
    qCode,
  } = useGetClientData();

  useAddClientDataToState({ clientData, qCode });

  const { allSteps: steps, currentStepIndex } = useAddUpdateApplicationSteps(
    PHASE_1_CONFIG
  );

  const renderContent = () => {
    if (noQCode(qCode)) return <NoQCode />;
    if (isError) return <ErrorComponent />;
    if (isFetchingClientData) return <Loading />;
    if (noSteps(steps)) return <NoSteps />;
    if (showStart(currentStepIndex)) return <CheckPoint />;
    if (showFinished({ steps, currentStepIndex })) return <Finished />;

    const StepComponent = getCurrentStepComponent({
      steps,
      currentStepIndex,
    });
    return StepComponent ? (
      <StandardStepContent>
        <StepComponent />
        <NextStepButton />
      </StandardStepContent>
    ) : null;
  };

  const renderPreviousButton = () => {
    return (
      <StandardStepNavbarWrapper>
        <PreviousStepButton />
      </StandardStepNavbarWrapper>
    );
  };

  return (
    <AppShell>
      {renderPreviousButton()}
      {renderContent()}
    </AppShell>
  );
};

export default UpdateApplicationStandAlone;
